import type * as ents from '@attain-apps/entities'
import * as graphql from '@attain-apps/fe/web/main/lib/graphql'
import gql from 'graphql-tag'

import * as fragments from '../../../gql/fragments'

const DOC = gql`
  ${fragments.responsiblePerson.DOC}
  query ClusterResponsiblePersons(
    $tenantId: ID!
    $zoneId: ID!
    $appId: ID!
    $scenarioId: ID!
    $clusterId: ID!
  ) {
    tenant(id: $tenantId) {
      zone(id: $zoneId) {
        app(id: $appId) {
          scenario(id: $scenarioId) {
            extra {
              space {
                clusterResponsiblePersons(clusterId: $clusterId) {
                  ...FragmentResponsiblePerson
                }
              }
            }
          }
        }
      }
    }
  }
`

const TRANSFORMER = graphql.transformers.OUT.default(
  graphql.transformers.OUT.select<
    graphql.schema.ClusterResponsiblePersonsQuery,
    ents.extra.space.Record.ResponsiblePerson[],
    'tenant'
  >(
    'tenant',
    graphql.transformers.OUT.select(
      'zone',
      graphql.transformers.OUT.select(
        'app',
        graphql.transformers.OUT.select(
          'scenario',
          graphql.transformers.OUT.select(
            'extra',
            graphql.transformers.OUT.select(
              'space',
              graphql.transformers.OUT.select(
                'clusterResponsiblePersons',
                graphql.transformers.OUT.list(
                  fragments.responsiblePerson.TRANSFORMER,
                  { onNullish: 'remove' },
                ),
              ),
            ),
          ),
        ),
      ),
    ),
  ),
  [],
)

export const executor = graphql.createExecutor<
  graphql.schema.ClusterResponsiblePersonsQuery,
  ents.extra.space.Record.ResponsiblePerson[],
  graphql.schema.ClusterResponsiblePersonsQueryVariables
>({
  query: DOC,
  transformer: TRANSFORMER,
})
